const firebaseConfig = {
  apiKey: "AIzaSyDppq65p9v1mdIBvp2hHuQV-S5JcYT7548",
  authDomain: "hr-vettie-portal.firebaseapp.com",
  databaseURL: "https://hr-vettie-portal-default-rtdb.firebaseio.com/",
  projectId: "hr-vettie-portal",
  storageBucket: "hr-vettie-portal.appspot.com",
  messagingSenderId: "482227178390",
  appId: "1:482227178390:web:ac106d16aaabf8434dabb7",
  measurementId: "G-SRLRHG67VZ"
};

export { firebaseConfig };